import { IonAccordion, IonAccordionGroup, IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonPage, IonRow, IonText, IonTitle, IonToolbar,  useIonViewWillEnter } from '@ionic/react';
import { personCircleOutline } from 'ionicons/icons';
import { useAppContext } from '../AppProvider';
import { useRef } from 'react';

const FAQ: React.FC = () => {

  const { SWFullHorizLogo, textLogoLoaded, fadeInTextLogo } = useAppContext();

  const accordionGroup = useRef<null | HTMLIonAccordionGroupElement>(null);         

  useIonViewWillEnter(() => {
      document.body.classList.remove('dark');
  });
  
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
            <IonButtons slot='start'>
                <IonBackButton color={'tertiary'}>Back</IonBackButton>
            </IonButtons>
            <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>            
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding account-content-bg">
        <div>
            <h1 className='ion-text-center'>SoloWise FAQ</h1>
        </div>
        <IonGrid fixed>
            <IonRow class='ion-justify-content-center'>
                <IonCol size='12' sizeMd='8' sizeLg='8' sizeXl='8'>
                    <IonCard>
                        <IonCardContent id='AboutContent'>
                            <p><IonText color={'tertiary'}><strong>Frequently Asked Questions</strong></IonText></p>

                            <hr />

                            <IonAccordionGroup className='ion-margin-bottom ion-margin-top' ref={accordionGroup}>
                            
                                <IonAccordion value="timers">
                                    <IonItem slot="header" color="light">
                                        <IonLabel>How do SoloWise Timers work?</IonLabel>
                                    </IonItem>
                                    <div slot="content">
                                        <IonCard>
                                            <IonCardContent>
                                                <p>A SoloWise Timer schedules a check-in for a Place or Route. Timers may be set to run during a one-time event or repeat automatically on selected days of the week.</p>
                                                <p>You can select a saved Place or Route, or create a new one while setting the Timer.</p>
                                                <p>You must have at least one confirmed Contact before you can set a Timer.</p>
                                                <p>One-time Timers require a scheduled start time to provide coverage for a specific period. Daily Timers do not require a start time and automatically cover a 24-hour cycle.</p>
                                                <p>When the check-in time arrives, you will receive a reminder to check in. You must be in a location with an internet or cellular connection, so you are able to check in. Checking in to a Daily Timer will automatically reset the check-in time to the next selected day.</p>
                                                <p>You may set an Alarm Delay to provide a grace period to check in. If you do not check in before the Alarm Delay expires, SoloWise will automatically alert the Contact(s) assigned to the Timer.</p>
                                            </IonCardContent>
                                        </IonCard>
                                    </div>
                                </IonAccordion>

                                <IonAccordion value="tracking">
                                    <IonItem slot="header" color="light">
                                        <IonLabel>Does SoloWise track my location?</IonLabel>
                                    </IonItem>
                                    <div slot="content">
                                        <IonCard>
                                            <IonCardContent>
                                                <p>Location tracking by SoloWise is entirely optional. It is turned off by default, and you need to grant permission for SoloWise to access your device's location data. Once permission is granted, you can choose to deny permission at any time.</p>
                                            </IonCardContent>
                                        </IonCard>
                                    </div>
                                </IonAccordion>

                                <IonAccordion value="phone">
                                    <IonItem slot="header" color="light">
                                        <IonLabel>Do I need a smart phone to use SoloWise?</IonLabel>
                                    </IonItem>
                                    <div slot="content">
                                        <IonCard>
                                            <IonCardContent>
                                                <p>No, your SoloWise account, including your Timers, can be managed through our web app, using either a tablet, a laptop, or desktop computer. Just open your favorite web browser and go to https://app.besolowise.com/</p>
                                            </IonCardContent>
                                        </IonCard>
                                    </div>
                                </IonAccordion>

                                <IonAccordion value="911">
                                    <IonItem slot="header" color="light">
                                        <IonLabel>Does SoloWise directly call 911 or search-and-rescue agencies?</IonLabel>
                                    </IonItem>
                                    <div slot="content">
                                        <IonCard>
                                            <IonCardContent>
                                                <p>No, SoloWise does not directly call 911 or any search-and-rescue agencies. SoloWise only alerts your personal emergency contacts you set-up and select.</p>
                                            </IonCardContent>
                                        </IonCard>
                                    </div>
                                </IonAccordion>

                            </IonAccordionGroup>

                            <hr className='ion-margin' />

                            <div className='ion-margin-bottom ion-margin-top ion-text-center'>
                              <IonButton className='ion-margin' color={'secondary'} type='button' expand='block' routerLink='/register'>
                                  Sign Up Now <IonIcon icon={personCircleOutline} slot='end'></IonIcon>
                              </IonButton>
                            </div>
                            
                            <p className='ion-margin-top ion-text-center'>Contact our Member Support Team at support@besolowise.com for additional information or assistance.</p>

                        </IonCardContent>
                    </IonCard>
                </IonCol>
            </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default FAQ;
